export class PriceUploadExcelViewModel {
    areaCode: string;
    WeightCode:string;
    price: number;
}